import { render, staticRenderFns } from "./LaudoInsercaoDeDiuGuiadoPorTransvaginal.vue?vue&type=template&id=002a7039&"
import script from "./LaudoInsercaoDeDiuGuiadoPorTransvaginal.vue?vue&type=script&lang=js&"
export * from "./LaudoInsercaoDeDiuGuiadoPorTransvaginal.vue?vue&type=script&lang=js&"
import style0 from "./LaudoInsercaoDeDiuGuiadoPorTransvaginal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VIcon,VRow,VSpacer})
